import $ from 'jquery'
import { init } from './abt-core/app'
import { setPublicPath } from './abt-core/public-path'

setPublicPath()

/** Detects if the AB testing framework should be loaded. */
var isAutoAddToCart = !!window.catid && window.catid === 'pcmcat152200050035'
var isDeals = /(blackfriday)\.bestbuy\.com$/.test(window.location.host)
var isEspanol = /espanol/.test(window.location.href)
var isKiosk = /kiosk/.test(window.location.href)

/** Generate url for the image server config. */
var protocol = window.location.protocol
var host = protocol === 'https:' ? 'img-ssl.bbystatic.com' : 'img.bbystatic.com'
var abtImgServerConfig = protocol + '//' + host + '/BestBuy_US/js/abtImgServerConfig.js'

if (isAutoAddToCart || isDeals || isEspanol || isKiosk) {
  // abort/do nothing
} else {
  /** Set global identifier that AB testing is on the page. */
  window.abTestFramework = true

  $.ajax({
    cache: true,
    dataType: 'script',
    url: abtImgServerConfig
  }).done(function () {
    init()
  })
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abtestInit.js
 ** module id = 66
 ** module chunks = 2
 **/